/**
 */
define('constant/consoleApi/oauth.rollout.constant',[], function () {
//一级分类
    var parentType =  [
        {key:"13",value:"应用"},
        {key:"2",value:"游戏"}
    ];

    var parentType4AppTouch =[
        {key:"21",value:"AppTouch"}
    ];
    var parentType4Server = [
        {key: "13", value: "应用"}];

    var languageWebAppList = [
        {key:"zh-CN",value:"简体中文",flag:false}
    ];

    var parentType4IosNative =[
        {key:"22",value:"iosNative"}
    ];



    var languageAppList =[
        {key: "zh-CN", value: "简体中文", flag: false}, {key: "zh-HK", value: "香港（中国）繁体中文", flag: false}, {key: "zh-TW", value: "台湾（中国）繁体中文", flag: false}, {key: "en-US", value: "美式英语", flag: false},
        {key: "en-GB", value: "英式英语", flag: false}, {key: "es-ES", value: "欧洲西语", flag: false}, {key: "pt-PT", value: "欧洲葡语", flag: false},
        {key: "de-DE", value: "德语", flag: false}, {key: "ru-RU", value: "俄语", flag: false}, {key: "es-419", value: "拉美西语", flag: false}, {key: "pt-BR", value: "巴西葡语", flag: false},
        {key: "it-IT", value: "意大利语", flag: false}, {key: "ja-JP", value: "日语", flag: false}, {key: "fr-FR", value: "法语", flag: false},
        {key: "sv-SE", value: "瑞典语", flag: false}, {key: "no-NO", value: "挪威语", flag: false}, {key: "da-DK", value: "丹麦语", flag: false}, {key: "cs-CZ", value: "捷克语", flag: false},
        {key: "pl-PL", value: "波兰语", flag: false}, {key: "ro", value: "罗马尼亚语", flag: false},{key: "hu-HU", value: "匈牙利语", flag: false}, {key: "sk", value: "斯洛伐克语", flag: false},
        {key: "bs", value: "波斯尼亚语", flag: false}, {key: "mk-MK", value: "马其顿语", flag: false},{key: "el-GR", value: "希腊语", flag: false}, {key: "sr", value: "塞尔维亚语", flag: false},
        {key: "et", value: "爱沙尼亚语", flag: false}, {key: "lv", value: "拉脱维亚语", flag: false}, {key: "bg", value: "保加利亚语", flag: false}, {key: "fi-FI", value: "芬兰语", flag: false},
        {key: "hr", value: "克罗地亚语", flag: false}, {key: "uk", value: "乌克兰语", flag: false},{key: "lt", value: "立陶宛语", flag: false}, {key: "sl", value: "斯洛文尼亚语", flag: false},
        {key: "id", value: "印尼语", flag: false}, {key: "ar", value: "阿拉伯语", flag: false},{key: "tr-TR", value: "土耳其语", flag: false}, {key: "vi", value: "越南语", flag: false},
        {key: "ms", value: "马来西亚语", flag: false}, {key: "ca", value: "加泰罗尼亚语", flag: false},{key: "nl-NL", value: "荷兰语", flag: false}, {key: "th", value: "泰语", flag: false},
        {key: "he_IL", value: "希伯来语", flag: false}, {key: "gl-ES", value: "加利西亚语", flag: false},{key: "hi-IN", value: "印地语", flag: false}, {key: "ko-KR", value: "韩语", flag: false},
        {key: "az-AZ", value: "阿塞拜疆语", flag: false}, {key: "uz", value: "乌兹别克语", flag: false},{key: "eu-ES", value: "巴斯克语", flag: false}, {key: "ka-GE", value: "格鲁吉亚语", flag: false},
        {key: "ur", value: "乌尔都语", flag: false}, {key: "bo", value: "藏语", flag: false},{key: "km-KH", value: "高棉语", flag: false}, {key: "si-LK", value: "僧伽罗语", flag: false},
        {key: "bn-BD", value: "孟加拉语", flag: false}, {key: "lo-LA", value: "老挝语", flag: false},{key: "be", value: "白俄罗斯语", flag: false}, {key: "kk", value: "哈萨克语", flag: false},
        {key: "fa", value: "波斯语", flag: false}, {key: "my-MM", value: "缅甸语", flag: false},{key: "jv", value: "爪哇语", flag: false}, {key: "ne-NP", value: "尼泊尔语", flag: false},
        {key: "mi_NZ", value: "毛利语", flag: false},{key: "am_ET", value: "阿姆哈拉语", flag: false}, {key: "fil", value: "菲律宾语", flag: false},{key: "sw_TZ", value: "斯瓦西里语", flag: false},
        {key: "ta_IN", value: "泰米尔语", flag: false},{key: "gu_IN", value: "古吉拉特语", flag: false}, {key: "te_IN", value: "泰卢固语", flag: false},{key: "mr_IN", value: "马拉地语", flag: false},
        {key: "or_IN", value: "欧里亚语", flag: false},{key: "pa_Guru_IN", value: "旁遮普语", flag: false},{key: "kn_IN", value: "卡纳达语", flag: false},{key: "ml_IN", value: "马来亚拉姆语", flag: false},
        {key: "mn_MN", value: "蒙古语（西里尔文）", flag: false},{key: "as_IN", value: "阿萨姆语", flag: false},{key: "mai_Deva_IN", value: "迈蒂利语", flag: false}

    ];

    var languageVrList = [
        {key:"zh-CN",value:"简体中文",flag:false},
        {key:"zh-HK",value:"香港（中国）繁体中文",flag:false},
        {key:"zh-TW",value:"台湾（中国）繁体中文",flag:false},
        {key:"en-US",value:"美式英语",flag:false},
        {key:"en-GB",value:"英式英语",flag:false}
    ];

    var languageIosList =[
        {key:"zh-CN",value:"简体中文"},
        {key:"en-GB",value:"英式英语"},
        {key:"en-US",value:"美式英语"}
    ];
    var languageTVList = [
        {
            key:"zh-CN",
            value:"简体中文"
        },
        {
            key:"en-US",
            value:"美式英语"
        }
    ];

    var languageWatchList =  [
        {key:"zh-CN",value:"简体中文"},
        {key:"zh-HK",value:"香港（中国）繁体中文"},
        {key:"zh-TW",value:"台湾（中国）繁体中文"},
        {key:"en-GB",value:"英式英语"},
        {key:"en-US",value:"美式英语"}
    ];



    var productTypes = [
        {
            "prodType":"1",
            "name":"移动应用",
            "parentType": parentType,
            "languageList": languageAppList,
            "authAdd":true,"authDelete":true,"authChange":true,"authQuery":true
        },
        {
            "prodType":"2",
            "name":"智慧屏应用",
            "parentType": parentType,
            "languageList": languageTVList,
            "authAdd":true,"authDelete":true,"authChange":true,"authQuery":true
        },
        {
            "prodType":"4",
            "name":"路由器应用",
            "parentType": parentType,
            "languageList": languageAppList,
            "authAdd":true,"authDelete":true,"authChange":true,"authQuery":true
        },
        {
            "prodType":"7",
            "name":"服务器应用",
            "parentType": parentType4Server,
            "languageList": languageWebAppList,
            "authAdd":true,"authDelete":true,"authChange":true,"authQuery":true
        },
        {
            "prodType":"8",
            "name":"华为VR应用",
            "parentType": parentType,
            "languageList": languageVrList,
            "authAdd":true,"authDelete":true,"authChange":true,"authQuery":true
        },
        {
            "prodType":"9",
            "name":"手表应用",
            "parentType": parentType,
            "languageList": languageWatchList,
            "authAdd":true,"authDelete":true,"authChange":true,"authQuery":true
        },
        {//只为了展示用  后面删除
            "prodType":"19-1",
            "name":"快应用",
            "parentType": parentType,
            "freeInstallType":"1",
            "languageList": languageAppList,
            "authAdd":true,"authDelete":true,"authChange":true,"authQuery":true
        },
        {//只为了展示用  后面删除
            "prodType":"19",
            "name":"快应用",
            "parentType": parentType,
            "freeInstallType":"1",
            "languageList": languageAppList,
            "authAdd":false,"authDelete":true,"authChange":true,"authQuery":true
        },
        {//只为了展示用  后面删除
            "prodType":"19-undefined",
            "name":"快应用",
            "parentType": parentType,
            "freeInstallType":"1",
            "languageList": languageAppList,
            "authAdd":false,"authDelete":true,"authChange":true,"authQuery":true
        },
        {
            "prodType":"19-2",
            "name":"免安装/H5应用",
            "parentType": parentType,
            "freeInstallType":"2",
            "languageList":languageWebAppList,
            "authAdd":false,"authDelete":true,"authChange":false,"authQuery":true
        },
        {
            "prodType":"16",
            "name":"免安装/H5应用",
            "parentType": parentType,
            "freeInstallType":"2",
            "languageList":languageWebAppList,
            "authAdd":false,"authDelete":true,"authChange":false,"authQuery":true
        },
        {
            "prodType":"21",
            "name":"AppTouch应用",
            "parentType": parentType4AppTouch,
            "languageList": languageAppList,
            "authAdd":false,"authDelete":true,"authChange":false,"authQuery":true
        },
        {
            "prodType":"22",
            "name":"IOS移动应用",
            "parentType": parentType4IosNative,
            "languageList": languageIosList,
            "authAdd":true,"authDelete":true,"authChange":true,"authQuery":true
        },
        {
            "prodType":"23",
            "name":"智慧屏快应用",
            "parentType": parentType4Server,
            "languageList": languageWebAppList,
            "authAdd":true,"authDelete":true,"authChange":true,"authQuery":true
        },
        {
            "prodType":"26",
            "name":"ePay产品",
            "parentType": parentType,
            "languageList": languageAppList,
            "authAdd":false,"authDelete":true,"authChange":false,"authQuery":true
        },
        {
            "prodType":"27",
            "name":"车机应用",
            "parentType": parentType,
            "languageList": languageAppList,
            "authAdd":true,"authDelete":true,"authChange":true,"authQuery":true
        },
        {
            "prodType":"28",
            "name":"车机快应用",
            "parentType": parentType,
            "languageList": languageAppList,
            "authAdd":true,"authDelete":true,"authChange":true,"authQuery":true
        },
        {
            "prodType":"29",
            "name":"Lite OS手表应用",
            "parentType": parentType,
            "languageList": languageAppList,
            "authAdd":false,"authDelete":true,"authChange":false,"authQuery":true
        },
        {
            "prodType":"40",
            "name":"鸿蒙应用",
            "parentType": parentType,
            "languageList": languageAppList,
            "authAdd":systemParaConf.switchConf.handlePCOrHarmonyShow>2,"authDelete":systemParaConf.switchConf.handlePCOrHarmonyShow>2,"authChange":systemParaConf.switchConf.handlePCOrHarmonyShow>2,"authQuery":systemParaConf.switchConf.handlePCOrHarmonyShow>2
        },
        {
            "prodType":"41",
            "name":"PC应用",
            "parentType": parentType,
            "languageList": languageAppList,
            "authAdd":systemParaConf.switchConf.handlePCOrHarmonyShow>1,"authDelete":systemParaConf.switchConf.handlePCOrHarmonyShow>1,"authChange":systemParaConf.switchConf.handlePCOrHarmonyShow>1,"authQuery":systemParaConf.switchConf.handlePCOrHarmonyShow>1
        },
        {
            "prodType":"42",
            "name":"PC快应用",
            "parentType": parentType,
            "languageList": languageAppList,
            "authAdd":true,"authDelete":true,"authChange":true,"authQuery":true
        },
    ];


    return {
        //产品名称的下拉参数 服务类型-产品类型 : 自己独有的参数
        getProAbsListParam:{
            '19-1':{freeInstallType:1},
            '19-2':{freeInstallType:2}
        },
        showPackageName:[6,8,33,43,52, 32,59],
        showFingerPrint:[6,8,33, 32,52],
        needVerified:[6,59,43,26],
        productTypes:productTypes,
        openStateFilter: { 1: '开通待审核', 2: '修改待审核', 3: '已开通', 4: '审核不通过'},
        contactTypeFilter:{1:'DPO',2:'代表人'},
        contactTypes:[{key:1,name:"DPO"},{key:2,name:"代表人"}],
        senstiveType:[{id:2,name:'全部类型'},{id:0,name:'公开'},{id:1,name:'敏感'}],
        openType:[{id:0,name:'全部状态'},{id:1,name:'已开通'},{id:2,name:'申请中'},{id:3,name:'不通过'}],
        projectScopeStatus:{
            1:'已开通',
            2:'申请中',
            3:'不通过'
        },
        projectScopeSenstive:{
            0:'公开',
            1:'敏感'
        }
    }
});

